import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { Progress, Button, dialog } from "nq-component";
import BaseListPage from "../../../../../base/BaseListPage";
import PayrollTablePresenter from "./PayrollTablePresenter";
import { formatCurrency } from "../../../../../components/common/Converter";
import { getHeaders } from "../payroll-table/header/PayrollHeaders.js";
import { getRowFields, getBorderFields } from "./header/PayrollRowFields.js";
import "../../../../../components/common/TablePayrollForm.css";
import FormFooter from "../form-footer/FormFooter";
import { PrintPayrollForm } from "../print-payroll/PrintPayrollForm";
import {
  calculateTotal,
  extractSalary,
} from "../payroll-table/calculation/PayrollCalculation";
import { Spin } from "antd";
import { renderDynamicFields } from "./helper-functions/PayrollHelperPage.js";

class PayrollTablePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PayrollTablePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    const storedName =
      localStorage.getItem("payrollName") || "MARY ANN Q.CARANTO";
    const storedPosition =
      localStorage.getItem("payrollPosition") ||
      "Chief, Administrative Division";

    this.state = {
      objects: [],
      loading: true,
      name: this.sanitizeInput(storedName),
      position: this.sanitizeInput(storedPosition),
      headerCount: 0,
      peraAda: {},
      numberofDays: 0,
      totalDaysDeduc: 0,
      sampleData2: 0,
      apAbsences: [],
      earnedBasicTotals: {},
      earnedPeraAdaTotals: {},
      basicEarning: {},
      peraAdaEarning: {},
      proratedRate: {},
      proratedPera: {},
      totalBasic: {},
      totalPera: {},
      netAmounts: {},
      netAmountsJO: {},
      netAmountIND: {},
      overpaymentBasic: {},
      flagRaising: {},
      overpaymentPera: {},
      noOfDuties: {},
      earnedApTotals: {},
      apRate: {},
      contributionType: [],
      contributionList: [],
      csvList: [],
      savedCsvEntries: props.csvData || [],
      amounts: {},
      taxTableList: [],
      tax: {},
      taxJO: {},
      taxIND: {},
      allowanceList: [],
      mandatory: {},
      absenceDays: {},
      absenceMins: {},
      earnedForPeriod: {},
      isTriggered: false,
      date: 0,
    };
  }

  getCollectionName() {
    return "payroll_table";
  }

  async componentDidMount() {
    const { startDate, endDate, data } = this.props;

    const startdate = new Date(startDate);
    const day = startdate.getDate();

    try {
      let id = [];

      for (const item of data) {
        id.push(item?.id);
      }

      const [
        inputData,
        contributions,
        contribution,
        csvSaved,
        taxTable,
        allowance,
      ] = await Promise.all([
        findObjectUseCase().execute("payroll_table"),
        findObjectUseCase().execute("contribution_type"),
        findObjectUseCase().execute("contributions"),
        findObjectUseCase().execute("payroll_table", {
          where: { csvData: { $ne: [] } },
        }),
        findObjectUseCase().execute("tax-table"),
        findObjectUseCase().execute("allowances", {
          where: { empID: { $in: id } },
        }),
      ]);

      const allowancesByEmpID = allowance?.reduce((result, record) => {
        const empID = record?.empID;
        if (!result[empID]) {
          result[empID] = [];
        }
        result[empID].push(record);
        return result;
      }, {});

      const allowances = {
        allowance: allowancesByEmpID,
      };

      const csvList = [];
      const extractedTaxes = [];

      for (let i = 0; i < taxTable.length; i++) {
        const taxItem = taxTable[i];
        extractedTaxes.push({
          compensation: extractSalary(taxItem?.compensation) || 0,
          from: extractSalary(taxItem?.from) || 0,
          to: extractSalary(taxItem?.to) || 0,
          initial: extractSalary(taxItem?.initial) || 0,
          percent: parseFloat(taxItem?.percent.replace(/[^\d.]/g, "")) || 0,
        });
      }

      for (const item of csvSaved) {
        csvList.push(item?.csvData);
      }
      const overpaymentBasic = {};
      const overpaymentPera = {};
      const overpayment = {};
      const flagRaising = {};
      const peraAda = data.reduce((acc, { id }) => {
        acc[id] = 2000;
        return acc;
      }, {});
      const noOfDuties = {};

      const savedCsvEntries = csvList;

      for (const item of inputData) {
        const {
          employee_id,
          overpaymentBasic: ob,
          overpaymentPera: op,
          overpayment: ov,
          flagRaising: fr,
          peraAda: pa,
          noOfDuties: nd,
        } = item;

        overpaymentBasic[employee_id] = ob || 0;
        overpaymentPera[employee_id] = op || 0;
        overpayment[employee_id] = ov || 0;
        flagRaising[employee_id] = fr || 0;
        if (pa !== undefined) {
          peraAda[employee_id] = pa;
        }
        noOfDuties[employee_id] = nd || 0;
      }

      this.setState({
        numberofDays: 22,
        totalDaysDeduc: 1,
        overpaymentBasic,
        overpaymentPera,
        overpayment,
        flagRaising,
        peraAda,
        noOfDuties,
        sampleData2: 7,
        savedCsvEntries,
        contributionType: contributions,
        contributionList: contribution,
        loading: false,
        csvList: csvSaved,
        taxTableList: extractedTaxes,
        allowanceList: allowances,
        date: day,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  async componentDidUpdate(prevProps) {
    const { contributionType, csvList } = this.state;
    const {
      payrollType,
      employmentType,
      additionalSelectValue,
      otherDeduction,
      csvData,
      incentives,
      data,
    } = this.props;

    let updatedState = {};
    if (prevProps.additionalSelectValue !== additionalSelectValue) {
      const csvListPrev = [];
      for (const item of csvList) {
        csvListPrev.push(item.csvData);
      }
      const savedCsvEntries = csvListPrev;
      updatedState.savedCsvEntries = savedCsvEntries;
    }

    if (
      prevProps.employmentType !== employmentType ||
      prevProps.additionalSelectValue !== additionalSelectValue ||
      prevProps.otherDeduction !== otherDeduction ||
      prevProps.csvData !== csvData ||
      prevProps.incentives !== incentives
    ) {
      const [headers, subHeaders] = getHeaders(
        payrollType,
        employmentType,
        additionalSelectValue,
        otherDeduction,
        csvData,
        incentives,
        contributionType
      );

      const otherDeductionCount =
        otherDeduction.length > 0 ? otherDeduction.length : 0;

      const headerCount =
        headers.length + subHeaders.length + otherDeductionCount;

      updatedState.headerCount = headerCount;
    }

    if (Object.keys(updatedState).length > 0) {
      this.setState(updatedState);
    }
  }

  dialogClose() {
    dialog.close();
  }

  confirmChanges = async () => {
    this.setState({ isTriggered: true });
    this.dialogClose();
    const { name, position } = this.state;
    const { startDate, endDate, additionalSelectValue, payrollCode } =
      this.props;
    PrintPayrollForm(
      name,
      position,
      startDate,
      endDate,
      additionalSelectValue,
      payrollCode
    );
    return this.presenter.gethandleSave();
  };

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  sanitizeInput = (input) => {
    return input.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  };

  printPayroll = () => {
    dialog.fire({
      html: (
        <div>
          <div className="row p-2" style={{ textAlign: "center" }}>
            <p>
              <i
                className="bi bi-question-circle"
                style={{ color: "orange", fontSize: "20px" }}
              ></i>{" "}
              By clicking "OK", the status of your payroll will be marked as
              "Printed".
              <div className="mt-1">
                <b></b>
              </div>
            </p>
            <p
              style={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, .65)",
              }}
            >
              Please click on OK to confirm changes.
            </p>
            <hr />
          </div>
          <div className="w-100 d-flex justify-content-end gap-3 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={this.confirmChanges.bind(this)}
            >
              OK
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  };
  handleNameChange = (newName) => {
    this.setState({ name: this.sanitizeInput(newName) });
  };

  handlePositionChange = (newPosition) => {
    this.setState({ position: this.sanitizeInput(newPosition) });
  };

  handleSave = async () => {
    return this.presenter.gethandleSave();
  };

  //body
  renderBody = (params) => {
    return this.presenter.getrenderBody(params);
  };

  handleCancel = () => {
    this.props.closeAccess();
  };

  render() {
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <Progress />;
    const {
      objects,
      headerCount,
      name,
      position,
      loading,
      contributionType,
      contributionList,
      taxTableList,
      allowanceList,
      apAbsences,
    } = this.state;

    const {
      data,
      additionalSelectValue,
      employmentType,
      csvData,
      otherDeduction,
      incentives,
      employeesMins,
      payrollType,
      absences,
      counts,
      employeeID,
      selected,
    } = this.props;

    const [headers, subHeaders] = getHeaders(
      payrollType,
      employmentType,
      additionalSelectValue,
      otherDeduction,
      csvData,
      incentives,
      contributionType
    );

    const netAmountTotal = calculateTotal(
      this.state.netAmounts,
      formatCurrency
    );

    const otherDeductionType = otherDeduction
      .reduce((acc, item) => {
        if (
          item.deductionType === "Other Deduction" &&
          item.payrollType === payrollType &&
          item.employmentName === employmentType &&
          item.employmentType === additionalSelectValue
        ) {
          acc.push(item.otherDeduction);
        }
        return acc;
      }, [])
      .flat();

    const otherAdditionalType = otherDeduction
      .reduce((acc, item) => {
        if (
          item.deductionType === "Other Additional" &&
          item.payrollType === payrollType &&
          item.employmentName === employmentType &&
          item.employmentType === additionalSelectValue
        ) {
          acc.push(item.otherDeduction);
        }
        return acc;
      }, [])
      .flat();

    const allowancesHeader = incentives
      .reduce((acc, item) => {
        acc.push(item.otherAllowances);
        return acc;
      }, [])
      .flat();

    const additionalHeader = incentives
      .reduce((acc, item) => {
        acc.push(item.otherAdditional);
        return acc;
      }, [])
      .flat();

    const contributions = contributionType.reduce((acc, item) => {
      acc.push({
        contributionType: item.contributionType,
        roundDown: item.roundDown || "",
        roundUp: item.roundUp || "",
      });
      return acc;
    }, []);

    const fields = getRowFields(
      payrollType,
      employmentType,
      additionalSelectValue,
      incentives
    );

    const individual = data.filter((item) => item.id === employeeID);

    const dataMapping =
      payrollType === "Individual Payroll"
        ? selected
        : payrollType === "J.O Salary" &&
          additionalSelectValue === "Addendum Payroll"
        ? selected
        : data;

    console.log("dataMapping", dataMapping);

    const isGraduated = [];
    const isSubmitted = [];
    const twentyFourSeven = [];
    const extractedSalaries = [];
    const positionLevel = [];
    const extractedAprate = [];
    for (let i = 0; i < dataMapping.length; i++) {
      isGraduated.push(dataMapping[i].isGraduated);
      isSubmitted.push(dataMapping[i].isSubmitted);
      const extractedSalary = extractSalary(dataMapping[i].salaryGrade);

      const extractedAP = extractSalary(dataMapping[i].payCode);

      const extractedValue = extractSalary(dataMapping[i].twentyFourSeven);
      twentyFourSeven.push(extractedValue !== null ? extractedValue : 0);
      extractedSalaries.push(extractedSalary !== null ? extractedSalary : 0);
      extractedAprate.push(extractedAP !== null ? extractedAP : 0);
      const position = dataMapping[i].position;
      if (position) {
        positionLevel.push(dataMapping[i].position["position_title"]);
      }
    }

    return (
      <>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center p-5">
            <Spin size="large" />
          </div>
        ) : (
          <div className="table-container">
            <div className="table-wrapper">
              <table className="payroll-table" id="payroll-table">
                <thead>
                  <tr>
                    {headers.map((header, index) => (
                      <th
                        key={index}
                        colSpan={header.colSpan}
                        rowSpan={header.rowSpan}
                      >
                        {header.label}
                      </th>
                    ))}
                  </tr>
                  {subHeaders.length > 0 && (
                    <tr>
                      {subHeaders.map((label, index) => (
                        <th key={index}>{label}</th>
                      ))}

                      {(additionalSelectValue === "General Payroll" ||
                        additionalSelectValue === "Addendum Payroll" ||
                        additionalSelectValue === "Addendum Back-Pay" ||
                        additionalSelectValue === "Last Salary (AP)") && (
                        <>
                          {otherDeductionType.length === 0
                            ? ""
                            : otherDeductionType.map((label, index) => (
                                <th key={index}>{label}</th>
                              ))}

                          {otherAdditionalType.length === 0
                            ? ""
                            : otherAdditionalType.map((label, index) => (
                                <th key={index}>{label}</th>
                              ))}
                        </>
                      )}
                    </tr>
                  )}
                </thead>
                <tbody>
                  {this.renderBody({
                    fields,
                    csvData: csvData || this.state.savedCsvEntries,
                    otherDeductionType,
                    otherAdditionalType,
                    allowancesHeader,
                    additionalHeader,
                    data,
                    employeesMins,
                    headerCount,
                    contributions,
                    contributionList,
                    isGraduated,
                    isSubmitted,
                    twentyFourSeven,
                    extractedSalaries,
                    extractedAprate,
                    taxTableList,
                    allowanceList,
                    absences,
                    counts,
                    positionLevel,
                  })}
                </tbody>
                {(additionalSelectValue === "General Payroll" ||
                  additionalSelectValue === "Addendum Payroll") && (
                  <tfoot>
                    <tr>
                      {fields.map((field, colIndex) => {
                        const tdStyle = {
                          border: getBorderFields().includes(field)
                            ? "1px solid #ddd"
                            : "none",
                          fontWeight: "bold",
                        };

                        if (field === "OtherDeduction") {
                          return renderDynamicFields(
                            field,
                            otherDeductionType,
                            tdStyle
                          );
                        }

                        if (field === "OtherAdditional") {
                          return renderDynamicFields(
                            field,
                            otherAdditionalType,
                            tdStyle
                          );
                        }

                        if (field === "contributions") {
                          return renderDynamicFields(
                            field,
                            contributions,
                            tdStyle
                          );
                        }

                        return (
                          <td key={colIndex} style={tdStyle}>
                            {{
                              netAmount: netAmountTotal,
                              Middlename: (
                                <p style={{ fontSize: "14px" }}>Total:</p>
                              ),
                            }[field] || ""}
                          </td>
                        );
                      })}
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>
        )}

        <FormFooter
          name={name}
          position={position}
          onNameChange={this.handleNameChange}
          onPositionChange={this.handlePositionChange}
        />
        <div className="w-100 d-flex justify-content-end gap-2 mb-3 pe-3">
          <Button
            type="button"
            className="btn btn-primary"
            onClick={this.handleSave}
          >
            Save
          </Button>
          <Button className="btn btn-light" onClick={this.handleCancel}>
            Cancel
          </Button>
          <Button className="btn btn-primary" onClick={this.printPayroll}>
            Print
          </Button>
        </div>

        <hr></hr>
      </>
    );
  }
}

export default PayrollTablePage;
